import { UserManager } from "oidc-client-ts";
import type { UserManagerSettings } from "oidc-client-ts";

export function createUserManager(settings: UserManagerSettings): UserManager {
  return new UserManager(settings);
}

